import { createAsyncThunk } from '@reduxjs/toolkit'
import debounce from 'lodash/debounce'
import geohash from 'ngeohash'
import toast from 'react-hot-toast'
import * as endPoints from '@/endpoints'
import axios from '@/lib/axios'
// import{ easeCubic } from 'd3-ease'

// import * as turf from '@turf/turf'

import * as setUtils from '@/utils/setUtils'
// import {setCircuitFilterButton, setSSIDFilterButton, setFeederFilterButton} from './tab'

// import WebMercatorViewport from "@math.gl/web-mercator"
import {
    deleteAllSourceFeatures,
    filterBaseLayersByCircuitOrSSIDorFeeder,
    geohashesFetched,
    geohashesFetching,
    onChangeViewport,
    selectBuildingsCount,
    selectEHVLineCount,
    selectHVLineCount,
    selectLVLineCount,
    setSearchStatus,
    toggleBoundaryLayerVisibility
} from './map'

// import WebMercatorViewport from "@math.gl/web-mercator";
// /////////////////////////////////////////////////////////////////////////////////////////
// ///////////////// Util Functions ////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////

function getPrecisionFromZoom(zoom) {
    if (zoom >= 10 && zoom < 13) {
        return 4
    }
    if (zoom >= 13) {
        return 5
    }
}

// only used to tell the search result where to zoom to
// export function getZoomFromVoltageLevel(voltageLevel) {
//     if (voltageLevel === 'HV') {
//         return 13.1
//     } if (voltageLevel === 'EHV') {
//         return 15.1
//     } // LV
//     return 17.1
// }

export function getVoltageLevelsFromZoom(zoomLevel) {
    if (zoomLevel >= 4 && zoomLevel < 12) {
        return ['EHV']
    }
    if (zoomLevel >= 12 && zoomLevel < 15) {
        return ['HV', 'EHV']
    }
    if (zoomLevel >= 15 && zoomLevel <= 24) {
        return ['LV', 'HV', 'EHV']
    }
    return []
}

export function getPrecisionFromZoomAndVoltageLevel(
    zoomLevel,
    voltageLevel,
    nodeOrLine
) {
    if (voltageLevel === 'BUILDINGS') {
        if (zoomLevel >= 14) {
            return 5
        }
        return null
    }
    if (voltageLevel === 'LV') {
        if (zoomLevel >= 15) {
            return 6
        }
        return null
    }
    if (voltageLevel === 'HV') {
        if (zoomLevel >= 15) {
            if (nodeOrLine === 'NODE') {
                return 5
            }
            return 6
        }
        if (zoomLevel >= 12 && zoomLevel < 15) {
            return 5
        }
        return null
    }
    if (voltageLevel === 'EHV') {
        if (nodeOrLine === 'NODE') {
            return 3
        }
        if (zoomLevel >= 15) {
            return 6
        }
        if (zoomLevel >= 12 && zoomLevel < 15) {
            return 5
        }
        if (zoomLevel >= 4 && zoomLevel <= 11) {
            return 3
        }
        return null
    }
}

// /////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////// Thunks ///////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////

export const fetchPlanningAreas = createAsyncThunk(
    'map/fetchPlanningAreas',
    async (_, thunkAPI) => {
        const response = await axios.get('')
        return response.data
    }
)

export const fetchPopupFeatures = createAsyncThunk(
    'map/fetchPopupFeatures',
    async (
        { lon, lat, map },
        { getState, fulfillWithValue, rejectWithValue }
    ) => {
        const state = getState()
        const zoomLevel = parseInt(state.map.viewport.zoom, 10)
        const b64Lon = btoa(lon)
        const b64Lat = btoa(lat)
        const voltageLevels = getVoltageLevelsFromZoom(zoomLevel).join('-')

        const response = await axios.get(
            `${''}${b64Lon}/${b64Lat}/${zoomLevel}/${voltageLevels}/`
        )
        return response.data
    }
)

export const fetchBoundaries = createAsyncThunk(
    'map/fetchBoundaries',
    async (
        { dnoOrCouncil },
        { dispatch, getState, fulfillWithValue, rejectWithValue }
    ) => {
        try {
            const response = await axios.get(`${''}${dnoOrCouncil}/`)

            if (dnoOrCouncil === 'dno') {
                dispatch(
                    toggleBoundaryLayerVisibility({
                        stateName: 'shouldFetchDNOBoundaries',
                        layerName: 'DNO Boundaries'
                    })
                )
            } else if (dnoOrCouncil === 'council') {
                dispatch(
                    toggleBoundaryLayerVisibility({
                        stateName: 'shouldFetchCouncilBoundaries',
                        layerName: 'Council Boundaries'
                    })
                )
            }

            return fulfillWithValue(
                { visibleBoundaryData: response.data, dnoOrCouncil },
                { 'meta-stuff': 'blah' }
            )
        } catch (rejectedValueOrSerializedError) {
            // console.log('fetching boundaries - failure', rejectedValueOrSerializedError)
        }
    }
)
